import React, { useEffect, useState, useCallback } from "react";
import "../common/Util.css";
import { ReactComponent as SearchIc } from "../../assets/svg/search.svg";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import { ReactComponent as RarIc } from "../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../assets/svg/lar_ic.svg";
import "../common/skeleton-effect.css";
import { useNavigate } from "react-router-dom";
import { getLiveVehiclesApi } from "./live-view-api"; // placeholder - implement in live-view-api.js
import TruckProgressBar from "./truck-progress-bar";
import "./live-view.css";
import liveIcon from "../../assets/svg/live-view-ic.svg";
import tripIcon from "../../assets/svg/trip-liveview.svg";
import tripRouteIcon from "../../assets/svg/trip_route_ic.svg";
import receiverIcon from "../../assets/svg/receiver_ic.svg";
import { MapContainer, TileLayer, Marker, Popup, Polyline } from "react-leaflet";
import L from "leaflet";
import truckImg from "../../assets/png/delivery-truck.png";

export const LiveTrack = () => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState("");
  const [search, setSearch] = useState("");
  const [tripList, setTripList] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const statusOptions = [
    { value: "", label: "All" },
    { value: "Created", label: "Created" },
    { value: "Delivered", label: "Delivered" },
    { value: "Trip end", label: "Trip end" },
    { value: "InProgress", label: "InProgress" },
    { value: "Trip start", label: "Trip start" },
  ];

  const fetchVehicles = useCallback(async () => {
    setIsLoading(true);
    try {
      const params = {
        status: filter === "All" ? "" : filter,
        search,
      };
      // Implement getLiveVehiclesApi to call backend
      const resp = await getLiveVehiclesApi(filter);
      if (resp?.data?.success === true) {
        setTripList(resp.data.trip ?? []);
      } else {
        // fallback empty
        setTripList([]);
      }
    } catch (err) {
      console.error("Error loading live vehicles", err);
    } finally {
      setIsLoading(false);
    }
  }, [filter, search]);

  useEffect(() => {
    fetchVehicles();
  }, [fetchVehicles]);

  const createCustomMarker = (text) =>
    L.divIcon({
      className: "custom-icon",
      html: `
        <div style="position: relative; display: inline-block;">
          <!-- Your image from assets -->
          <img src="${truckImg}" style="width:20px;height:50px;" />
          
          <!-- Text overlay -->
          <span style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white;
            font-size: 14px;
            font-weight: bold;
          ">
            ${text}
          </span>
        </div>
      `,
      iconSize: [40, 40],
      iconAnchor: [20, 40],
      popupAnchor: [0, -40],
    });

  return (
    <div className="bg-half-white pt-2 rounded-4" style={{ width: "100%" }}>
      <div className="bg-white rounded-4 p-3 " style={{ width: "100%" }}>
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex flex-column align-items-start justify-content-center">
            <div>
              <img src={liveIcon} alt="Live Icon" /> <span className="fs-20 fw-600 textcolor">Live view</span>
            </div>
            <div className="textFontColor fs-13 fw-400">Instant access to what's happening now and monitoring all the trip vehicles.</div>
          </div>

          {/* <div className="d-flex align-items-center gap-2">
              <div className="search-wrapper d-flex align-items-center gap-2 px-3 py-2">
                <SearchIc />
                <input
                  type="text"
                  placeholder="Search"
                  className="border-0 outline-0 rounded-3 fs-14 fw-500 textcolor"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div> */}
        </div>

        <div className="d-flex mt-3">
          {/* Left list panel */}
          <div style={{ width: "366px" }}>
            <div
              className="rounded-3 p-3"
              style={{
                height: "78vh",
                overflowY: "auto",
                background: "#F5F5F5",
              }}
            >
              <div
                className="d-flex gap-2 mb-3"
                style={{
                  overflowX: "auto",
                  whiteSpace: "nowrap",
                  paddingBottom: "6px",
                }}
              >
                {statusOptions.map((item, index) => (
                  <button
                    key={index}
                    className={`btn btn-sm ${filter === item.value ? "selected-btn" : "deselect-btn"}`}
                    style={{ whiteSpace: "nowrap" }} // prevent button text wrapping
                    onClick={() => setFilter(item.value)}
                  >
                    {item.label}
                  </button>
                ))}
              </div>

              {isLoading ? (
                <>
                  {Array.from({ length: 4 }).map((_, idx) => (
                    <div key={idx} className="bg-white rounded-4 p-3 mb-3">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="d-flex align-items-center gap-2">
                          <div className="skeleton" style={{ width: "36px", height: "36px", borderRadius: "50%" }} />
                          <div className="skeleton skeleton-text" style={{ width: "80px" }} />
                        </div>
                        <div className="skeleton skeleton-badge" />
                      </div>

                      <div className="mb-3">
                        <div className="skeleton" style={{ width: "100%", height: "8px", borderRadius: "4px" }} />
                      </div>

                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="d-flex flex-column gap-1">
                          <div className="skeleton skeleton-text-sm" style={{ width: "70px" }} />
                          <div className="skeleton skeleton-text-sm" style={{ width: "60px" }} />
                        </div>
                        <div className="d-flex flex-column gap-1">
                          <div className="skeleton skeleton-text-sm" style={{ width: "60px" }} />
                          <div className="skeleton skeleton-text-sm" style={{ width: "60px" }} />
                        </div>
                      </div>

                      <div className="divider"></div>

                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                          <div className="skeleton" style={{ width: "44px", height: "44px", borderRadius: "8px" }} />
                          <div className="d-flex flex-column gap-2">
                            <div className="skeleton skeleton-text-sm" style={{ width: "100px" }} />
                            <div className="skeleton skeleton-text-sm" style={{ width: "80px" }} />
                          </div>
                        </div>
                        <div className="d-flex gap-2">
                          <div className="skeleton" style={{ width: "36px", height: "36px", borderRadius: "50%" }} />
                          <div className="skeleton" style={{ width: "36px", height: "36px", borderRadius: "50%" }} />
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  {(tripList.length ? tripList : []).map((v, idx) => (
                    <div
                      key={v.id}
                      className="bg-white rounded-4 p-3 mb-3"
                      style={{
                        border: hoveredIndex === idx ? "1px solid #E6EEF8" : "1px solid #EEF2F6",
                      }}
                      onMouseEnter={() => setHoveredIndex(idx)}
                      onMouseLeave={() => setHoveredIndex(null)}
                    >
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center justify-content-center">
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{
                              width: "36px",
                              height: "36px",
                              borderRadius: "100px",
                              background: "#F6F6F6",
                            }}
                          >
                            <img src={tripIcon} alt="Live Icon" />
                          </div>{" "}
                          <span className="ms-2 fs-14 fw-500">#{v.trip_id}</span>
                        </div>
                        <div
                          className="badge trip-status-badge"
                          style={{
                            background: v.status === "In Transit" ? "#EAF0FF" : v.status === "Delivered" ? "#ECFDF5" : "#FFF4E6",
                            color: v.status === "In Transit" ? "#3469E7" : v.status === "Delivered" ? "#059669" : "#B45309",
                            padding: "6px 10px",
                            borderRadius: 12,
                          }}
                        >
                          {v.status}
                        </div>
                      </div>

                      <div className="mt-2">
                        <div
                          style={{
                            height: 8,
                            display: "flex",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          {/* visual timeline dots */}
                          {/* {Array.from({ length: 8 }).map((_, i) => (
                        <div
                          key={i}
                          style={{
                            width: 8,
                            height: 8,
                            borderRadius: 8,
                            background: i < 3 ? "#0C62B8" : "#E6EEF8",
                          }}
                        />
                      ))} */}
                          <TruckProgressBar totalStops={v.total_stops} currentStop={v.total_stops - v.pending_stops} showLabels={true} />
                        </div>

                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <div className="d-flex flex-column align-items-start">
                            <div className="time-text-batch">STARTED ON</div>
                            <div className="mt-2 time-text-value">{v.start_date ?? "--:--"}</div>
                          </div>
                          <div className="d-flex flex-column align-items-end">
                            <div className="time-text-batch">ENDS ON</div>
                            <div className="mt-2 time-text-value">{v.end_date ?? "--:--"}</div>
                          </div>
                        </div>
                      </div>
                      <div className="divider"></div>
                      <div className="w-100 d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-2" style={{ flex: 1 }}>
                          <div
                            style={{
                              width: 44,
                              height: 44,
                              borderRadius: 8,
                              background: "#F4F4F6",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {v.driverDetails?.length > 0 ? v.driverDetails[0]?.driver_name?.charAt(0) ?? "D" : "D"}
                          </div>
                          <div>
                            <div className="trip-batch-driver break-word">{v.driverDetails?.length > 0 ? v.driverDetails[0]?.driver_name ?? "---" : "---"}</div>
                            <div className="mt-2 trip-batch-vehicle break-word">{v.license_plate ?? ""}</div>
                          </div>
                        </div>

                        <div className="d-flex gap-2" /* style={{ width: "86px" }} */>
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate("/triptrack", {
                                state: { id: v.id, tripCode: v.trip_id },
                              });
                            }}
                            className="d-flex align-items-center justify-content-center"
                            style={{
                              width: "36px",
                              height: "36px",
                              borderRadius: "100px",
                              background: "#FFFFFF",
                              border: " 1px solid #EBEBEB",
                            }}
                          >
                            <img src={tripRouteIcon} alt="Trip Route Icon" />
                          </div>

                          {v.driverDetails?.length > 0 && (
                            <div
                              onClick={() => (window.location.href = `tel:${v.driverDetails[0]?.mobile_number ?? ""}`)}
                              className="d-flex align-items-center justify-content-center"
                              style={{
                                width: "36px",
                                height: "36px",
                                borderRadius: "100px",
                                background: "#FFFFFF",
                                border: " 1px solid #EBEBEB",
                              }}
                            >
                              <img src={receiverIcon} alt="Receiver Icon" />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>

          {/* Right map panel */}
          <div style={{ flex: 1 }}>
            <div className="bg-white rounded-4 " style={{ height: "78vh", position: "relative" }}>
              {isLoading ? (
                <div className="d-flex align-items-center justify-content-center" style={{ height: "100%", width: "100%" }}>
                  <div className="skeleton skeleton-map" style={{ height: "100%", width: "100%", borderRadius: "16px" }} />
                </div>
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: 8,
                    background: "linear-gradient(180deg,#f8fafc,#ffffff)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#9CA3AF",
                  }}
                >
                  <MapContainer center={[30, 0]} zoom={2} style={{ height: "100%", width: "100%" }}>
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' />

                    {/* Markers for route 1 */}

                    {tripList
                      .filter((trip) => trip.latitude !== null && trip.longitude !== null && trip.latitude !== "" && trip.longitude !== "")
                      .map((trip, index) => (
                        <Marker key={`Truck${index}`} position={[trip.latitude, trip.longitude]} icon={createCustomMarker(index + 1)}>
                          <Popup>
                            <div
                              style={{
                                width: 320,
                                background: "white",
                                padding: 12,
                                borderRadius: 12,
                                boxShadow: "0 6px 18px rgba(14,30,37,0.08)",
                              }}
                            >
                              <div
                                className="d-flex align-items-center justify-content-start"
                                style={{
                                  background: "#F5F5F5",
                                  padding: "6px",
                                  borderRadius: "12px",
                                }}
                              >
                                <div
                                  className="d-flex align-items-center justify-content-center"
                                  style={{
                                    width: "36px",
                                    height: "36px",
                                    borderRadius: "100px",
                                    background: "#F6F6F6",
                                  }}
                                >
                                  <img src={tripIcon} alt="Live Icon" />
                                </div>{" "}
                                <div className="ms-2 d-flex flex-column align-items-start">
                                  <span className="fs-14 fw-500">#{trip.trip_id}</span>
                                  <div className="fs-12 text-muted">Started on {trip.start_date ?? "---"}</div>
                                </div>
                              </div>

                              <div className="w-100 d-flex align-items-center justify-content-between mt-3">
                                <div className="d-flex align-items-center gap-2" style={{ flex: 1 }}>
                                  <div
                                    style={{
                                      width: 44,
                                      height: 44,
                                      borderRadius: 8,
                                      background: "#F4F4F6",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {trip.driverDetails?.length > 0 ? trip.driverDetails[0]?.driver_name?.charAt(0) ?? "D" : "D"}
                                  </div>
                                  <div>
                                    <div className="trip-batch-driver break-word">{trip.license_plate ?? ""}</div>
                                    <div className="trip-batch-vehicle">{trip.driverDetails?.length > 0 ? trip.driverDetails[0]?.mobile_number ?? "---" : "---"}</div>
                                  </div>
                                </div>

                                <div
                                  className="d-flex gap-2"
                                /* style={{ width: "86px" }} */
                                >
                                  <div
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      navigate("/trips/view", {
                                        state: { id: trip.id },
                                      });
                                    }}
                                    className="d-flex align-items-center justify-content-center"
                                    style={{
                                      width: "36px",
                                      height: "36px",
                                      borderRadius: "100px",
                                      background: "#F6F6F6",
                                    }}
                                  >
                                    <img src={tripRouteIcon} alt="Trip Route Icon" />
                                  </div>

                                  {trip.driverDetails?.length > 0 && (
                                    <div
                                      onClick={() => (window.location.href = `tel:${trip.driverDetails[0]?.mobile_number ?? ""}`)}
                                      className="d-flex align-items-center justify-content-center"
                                      style={{
                                        width: "36px",
                                        height: "36px",
                                        borderRadius: "100px",
                                        background: "#F6F6F6",
                                      }}
                                    >
                                      <img src={receiverIcon} alt="Receiver Icon" />
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="mt-2 d-flex align-items-center justify-content-start">
                                <div className="stops-count-badge">{trip.total_stops} stops</div>
                                <div className="ms-2 fs-12 text-muted">•</div>
                                <div className="badge distance-batch ms-2">
                                  <span>Distance : </span>{" "}
                                  <span className="fs-11 fw-500" style={{ color: "#6710A8" }}>
                                    {trip.distance_km ?? "0"} KM
                                  </span>
                                </div>
                              </div>
                            </div>
                          </Popup>
                        </Marker>
                      ))}

                    {/* Polylines */}
                    {/* <Polyline positions={route1} color="blue" weight={4} />
                         <Polyline positions={route2} color="red" weight={4} dashArray="5,10" /> */}
                  </MapContainer>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
